import React from 'react';
import './HomePage.css';
import './AboutPage.css';

function AboutPage() {
  return (
    <div className="home-page about-page" role="main" aria-label="About The Month in Bath">
      <header className="home-header">
        <h1>About Us</h1>
        <p>Month in Bath Talking Magazine</p>
      </header>

      <main className="home-content about-content">
        <section className="about-section">
          <h2>Welcome</h2>
          <p>
            Month in Bath has been bringing local news to the blind and partially sighted community for over twenty years. Until now this friendly audio magazine has not been available online, but this has recently changed with the creation of this easily accessible website.
          </p>

          <p>
            There is local news and information, but also recipes, gardening tips and local sports news. Interviews, stories and poetry sometimes feature.
          </p>

          <p>
            You can also contact us through this new site.
          </p>

          <p>
            Previously listeners had to sign up to have a memory stick sent to them once a month with the current edition recorded on it. The memory stick is played back with a small speaker unit that is provided. This free service is still available.
          </p>

          <p>
            There are over 300 local groups in the UK providing free weekly or monthly audio recordings for the blind and partially sighted community, or those who have difficulty accessing the printed word.
          </p>

          <p>
            Ronald Sturt, a senior librarian in Aberystwyth, started the Talking Newspaper movement in the UK in 1968, after witnessing a similar service in Sweden. The first recorded ‘newspaper’ was produced in January 1970 with support from the local Round Table.
          </p>

          <p>
            Month in Bath continues this long tradition.
          </p>

          <p>
            Wishing you a warm welcome into our community of listeners, from the Month in Bath volunteers
          </p>
        </section>

        <section className="about-section">
          <h2>Ways to Listen</h2>
          
          <div className="listen-method">
            <h3>Online</h3>
            <p>
              Anyone can find us and enjoy our content by visiting{' '}
              <a href="http://www.monthinbath.org" target="_blank" rel="noopener noreferrer">
                www.monthinbath.org
              </a>
            </p>
          </div>

          {/* <div className="listen-method">
            <h3>On Alexa</h3>
            <p>
              You can listen on Alexa. Simply say, <strong>"Alexa, play talking newspaper."</strong>
            </p>
            <p>
              You will be offered a choice of local talking newspapers. Just ask Alexa for <strong>Month in Bath</strong>.
            </p>
            <p>
              Alexa will offer you <em>Month in Bath Talking Magazine</em>, which is us!
            </p>
            <p className="note">
              Yes, slightly confusing. You have to ask Alexa to 'play talking newspaper', but then ask for <strong>Month in Bath Talking Magazine</strong>.
            </p>
          </div> */}

          <div className="listen-method">
            <h3>Using a Memory Stick</h3>
            <p>
              We can send you the talking newspaper each month, recorded on a USB memory stick. You listen to this on an easy-to-use player, provided to you free of charge.
            </p>
            <p>
              The Post Office generously distributes the USB sticks at no cost direct to listeners' homes. You send the USB stick back to us in a special wallet. Postage is free.
            </p>
            <p>
              To request this service email{' '}
              <a href="mailto:monthinbath@gmail.com?subject=USB%20Memory%20Stick%20Service%20Request">
                monthinbath@gmail.com
              </a>{' '}
              or phone <a href="tel:07986820877">07986 820877</a>.
            </p>
            <p>
              Please leave your details so that we can contact you, as we would need to arrange delivery of the playback speaker.
            </p>
          </div>
        </section>

        {/* <section className="about-section">
          <h2>Our History</h2>
          <p>
            Month in Bath was originally an audio magazine for visually impaired people living in or near Bath, but is now available to a wider audience. It was started nearly 40 years ago by Mrs Bindloss-Gibb who had Macular degeneration.
          </p>
          <div className="placeholder" style={{ minHeight: '200px', backgroundColor: '#f5f5f5', borderLeft: '4px solid #b8a8d4', padding: '1rem', marginTop: '1.5rem' }}>
            <p style={{ color: '#999', fontStyle: 'italic' }}>More content coming soon...</p>
          </div>
        </section>

        <section className="about-section">
          <h2>Our Volunteers</h2>
          <p>
            Month in Bath is recorded by local volunteers, who draw on their own expertise and interests to create a variety of magazine sections, from gardening tips to local sports news…
          </p>
          <div className="placeholder" style={{ minHeight: '200px', backgroundColor: '#f5f5f5', borderLeft: '4px solid #b8a8d4', padding: '1rem', marginTop: '1.5rem' }}>
            <p style={{ color: '#999', fontStyle: 'italic' }}>More content coming soon...</p>
          </div>
        </section> */}

        <section className="about-section">
          <h2>Listener Testimonials</h2>
          <blockquote>
            "Month in Bath is a lifeline for myself and many others. I especially enjoy Sarah who has a very clear voice."
            <cite>— Miss Carrie Thold, listener</cite>
          </blockquote>
          <blockquote>
            "Please thank your wonderful volunteers who keep us up to date with so many interesting articles."
            <cite>— Sally Houseman</cite>
          </blockquote>
          <blockquote>
            "My mum died aged 94 and in her later years your tapes meant so much to her – thank you."
            <cite>— Lesley</cite>
          </blockquote>
          <blockquote>
            "I love those savoury recipes."
            <cite>— Mrs Jenny Mitchinson</cite>
          </blockquote>
        </section>
      </main>
    </div>
  );
}

export default AboutPage;